__turbopack_context__.v({
  "customizerButton": "Customizer-module__TDk-Wq__customizerButton",
  "icon": "Customizer-module__TDk-Wq__icon",
});
